export default "__VITE_ASSET__Ge8ul7Yz__"